import { isValidEmailFormat, isValidPhoneListFormat } from './StringHelper'

/**
 * The format errors of the two fields that feed automated notifications.
 *
 * Shaped as the `errors` map the shared TextBox already knows how to paint -- keyed by field name,
 * each value carrying a `message` -- so the error appears under the field that holds it and only
 * under that one.
 *
 * Recomputed on every change, so the error appears as the value stops being well formed rather
 * than waiting for the save. An earlier comment claimed the opposite; the code never did that, and
 * the claim was removed rather than the behaviour. What the story asks is that the error show on
 * the field and that a malformed value not be saved, and this does both.
 *
 * The messages say what is expected rather than only that something is wrong. Whoever runs into
 * one may be opening an old request, not the person who typed the value -- folio SPS-0000009 will
 * greet whoever opens it with both of these.
 *
 * Lives here rather than beside one of the forms because both of them need it. Sales owns the
 * incident that produced it, but the warranty form carries the same two fields with the same
 * placeholders and feeds notifications of its own, so a helper reachable from a single view would
 * have forced one module to import from the other.
 *
 * @param {object} form the request being edited
 * @returns {object} a map of field name to error, empty when both fields are well formed
 */
export const notificationContactErrors = (form) => {
	const errors = {}
	if (!form) return errors

	if (!isValidEmailFormat(form.EmailsContact)) {
		errors.EmailsContact = { message: 'Enter valid email addresses separated by commas, e.g. correo@correo.com,otro@correo.com' }
	}
	if (!isValidPhoneListFormat(form.ContactPhone)) {
		errors.ContactPhone = { message: 'Enter phone numbers separated by commas, digits only, e.g. 7712333456,7798762345' }
	}
	return errors
}
